export const mutations = {
  TEMPLATE_RESET: "TEMPLATE_RESET"
};

export const actions = {
  TEMPLATE_ACCEPT_IMPORT: "templateAcceptImport"
};
